export const ColumnWidgetId = 'ColumnWidget';

export enum ColumnWidgetAttributes {
  ELEMENTS = 'columnElements',
}
